(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["power-pals-safety"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-safety-strip')) {
  customElements.define('pp-safety-strip',class extends HTMLElement {
    connectedCallback() {
      if(this._cleanup) return;
      const items=Array.from(this.querySelectorAll('.pps__item'));
      const cleanups=[];
      const listen=(target,event,fn)=>{target.addEventListener(event,fn);cleanups.push(()=>target.removeEventListener(event,fn));};
      let active=null;
      const setOpen=(item,open)=>{
        if(!item) return;
        item.classList.toggle('is-open',open);
        item.querySelector('.pps__trigger').setAttribute('aria-expanded',String(open));
        item.querySelector('.pps__extra').setAttribute('aria-hidden',String(!open));
      };
      const close=()=>{if(active){setOpen(active,false);active=null;}};
      items.forEach(item=>{
        listen(item,'click',event=>{
          if(event.target.closest('a')) return;
          const shouldOpen=active!==item;
          close();
          if(shouldOpen){setOpen(item,true);active=item;}
        });
      });
      listen(this,'keydown',event=>{
        if(event.key==='Escape' && active){event.preventDefault();const trigger=active.querySelector('.pps__trigger');close();trigger.focus();}
      });
      // Keep the selected card open while the visitor reads it.
      // Selecting a different card closes the previous one automatically.
      this._cleanup=()=>{close();cleanups.forEach(fn=>fn());};
    }
    disconnectedCallback(){if(this._cleanup)this._cleanup();this._cleanup=null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
